import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import { Link } from "react-router-dom";
import telia from "../images/telia.png";
import ellevio from "../images/ellevio.png";
import byggnadslov from "../images/1974_byggnadslov.png";
import styles from "../app.module.scss";

const InternetInfo = () => {
  return (
    <>
      <h2>Internet och TV</h2>
      <img src={telia} alt="Telia" className={styles.smallLeft} />

      <p>
        Internet- och TV-tjänsten tillhandahålls av Telia. Vi har optisk
        fiberanslutning (fast bredband).
      </p>

      <p>
        Vi har ett gruppavtal som täcker varje hushåll och tillhandahåller
        bas-tv-kanaler och 100/100 megabit internet till varje hus. Du kan också
        kontakta Telia och betala lite extra för att få fler tv-kanaler eller
        snabbare internethastighet.
      </p>

      <p>
        När du flyttar in kommer ditt internet troligen att kopplas bort
        eftersom de gamla ägarna tog med sig abonnemanget. Ring eller chatta med
        Telia direkt och sätt igång det, det tar väldigt lite tid.
      </p>
    </>
  );
};

const ElAnslutningInfo = () => {
  return (
    <>
      <h2>Elanslutning</h2>
      <img src={ellevio} alt="Ellevio" className={styles.smallLeft} />

      <p>
        Elen kopplad till ditt hus levereras av Ellevio. Du är fri att välja
        vilken elproducent som helst för att sälja dig faktiska kilowattimmar.
      </p>
      <p>
        Du kommer att få två fakturor varje månad: en från Ellevio och en från
        din valda producent. Priset per kilowattimme baseras på din valda
        tariff, men består i allmänhet av leveranskostnad (Ellevio), elskatt och
        kilowattimmekostnad (din valda producent).
      </p>

      <p>
        Bästa timmarna att bränna kilowatten är 22 till 6, och helger (alla
        timmar).
      </p>
    </>
  );
};

const HusFakta = () => {
  return (
    <>
      <h2>Lite fakta om ditt hus</h2>

      <img src={byggnadslov} alt="Byggnadslov" className={styles.mediumRight} />

      <ul>
        <li>
          Kvarteret är byggt 1974. Många hus är parhus med delad vägg — var
          snäll mot dina grannar.
        </li>
        <li>
          Husdesignerna är identiska men spegelvända, vissa är vänster (modell
          R5V), några höger (modell R5H).
        </li>
        <li>Husen är L-formade och har storleken 14x14m på utsidan.</li>
        <li>
          Den yttre väggtjockleken är 225 mm. Om du ska borra, skaffa en riktigt
          lång borr.
        </li>
        <li>
          Väggarna i ditt hus är gipsskivor. Så du kanske vill skaffa några
          verktyg för det.
        </li>
        <li>
          Du kan begära detaljerade byggplaner för ditt hus från
          Stadsbyggnadsnämnden, de skickar dig digitala skannade filer.
        </li>
        <li>
          De flesta husen runt omkring står på ett lager av lera som stöds av
          sten, ifall du skulle gräva ner. Vissa hus har stödpelare.
        </li>
        <li>
          De flesta husen har standard 3-fas 25A el-anslutning, vilket totalt är
          ca 5,7kW per fas. Du kommer att ha olika grenar i ditt hus kopplade
          till olika faser.
        </li>
        <li>
          Den ursprungligen installerade uppvärmningen är resistiva element som
          går på 400V (två faser) och i genomsnitt drar varje element 1-1,5kW
          när det går på full effekt. Alla hus borde vid det här laget också ha
          en värmepump, mycket effektivare värme- och kylanläggning.
        </li>
        <li>
          I 1974 det krävde inte jordledning till alla hushållsapparater, så du
          kommer att vara jordlös (bra att veta när du köper väggbrytare etc).
        </li>
      </ul>
    </>
  );
};

const Underhall = () => {
  return (
    <>
      <h2>Underhåll av ditt hus</h2>

      <ul>
        <li>
          Blockera eller täck inte över husets ytterväggar, för att förhindra
          fukt.
        </li>
        <li>Håll ett öga på vattenfläckar på dina väggar, tak och vindstak.</li>
        <li>
          Tänk på att använda trädgårdsolja på omålade träelement och staket.
        </li>
        <li>
          Tänk på att uppgradera taket inom dess beräknade livslängd. När man
          utför takarbete är det vettigt att även uppgradera 1974-erans
          isolering av vinden till modern standard.
        </li>
        <li>
          När du utför arbete på dina väggar och takpaneler: Mineralull används
          i takpaneler och väggisolering, använd hand- och andningsskydd.
        </li>
      </ul>
    </>
  );
};

export const PageNewcomers = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h2>Nyinflyttad?</h2>

        <p>
          Vi har sammanställt lite information om vad som gäller i vårt område.
        </p>

        <p>
          Ta gärna en titt, oavsett om du är helt ny eller har bott här länge.
        </p>

        <ul>
          <li>
            <Link to={`${process.env.PUBLIC_URL}/info.pdf`} target="_blank">
              Information för dig som bor i Torparängens samfällighetsförening
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/nya-parkeringsregler-2018.pdf`}
              target="_blank"
            >
              Nya parkeringsregler 2018
            </Link>
          </li>
        </ul>

        <p>
          Vill Du veta mer, lägga till något eller ändra, använd Kontakt och{" "}
          <Link to="/kontakt">skriv till oss</Link>.
        </p>

        <InternetInfo />
        <ElAnslutningInfo />
        <HusFakta />
        <Underhall />
      </ContentBox>
      <FooterBar />
    </>
  );
};
